import {get} from 'svelte/store';
import {combineLatest, switchMap, map, BehaviorSubject, distinctUntilChanged, shareReplay, startWith, interval, exhaustMap} from 'rxjs';
import {filter, debounceTime} from 'rxjs/operators';
import {mc} from '@/core';
import {isLogin$} from '@/streams/auth';
import {memeApi} from '@/api/meme';
import {numUtil} from '@/helper';
import {browser$} from '@/streams/browser';
import {LINKS} from '@/const/link';
import {fixLink$} from '@/store';

interface MemeXQueryProps {
  orderBy?: string;
  pageNum?: number;
  pageSize?: number;
}

const fixLink = get(fixLink$);

export const memeQuery$ = new BehaviorSubject<MemeXQueryProps>({});

const getMemeUpdate = async (ids = [], isLogin = false) => {
  const {data, error} = await memeApi.getMemeListUpdate({ids}, isLogin);
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data?.rows || [];
};

const getMemeList = async (params = {}) => {
  const {data, error} = await memeApi.getMemeList(params);
  if (error) {
    mc.send('toast', 'error', error);
  }
  return data?.rows || [];
};

const memeList$ = memeQuery$.pipe(
  filter((params) => params && !!Object.keys(params).length),
  debounceTime(200),
  switchMap((params) => {
    return getMemeList({...params});
  }),
  map((data) => data),
  distinctUntilChanged(),
  startWith([]),
  shareReplay(1)
);

const updator$ = combineLatest([isLogin$, memeList$]).pipe(
  filter(([, list]) => !!list.length),
  switchMap(([isLogin, list]) => {
    const ids = list.map((i) => i.id).join(',');
    return getMemeUpdate(ids, isLogin);
  })
);

// 10s轮询一次, 更新mmx价格
const memePriceMap$ = browser$.pipe(
  exhaustMap(() => {
    return interval(1e4)
      .pipe(startWith({}))
      .pipe(
        switchMap(() => updator$),
        map((data) =>
          data.reduce((pre, cur) => {
            pre[cur['ccy']] = cur;
            return pre;
          }, {})
        )
      );
  })
);

export const memeMarket$ = combineLatest([memeList$, memePriceMap$]).pipe(
  map(([list, priceMap]) => {
    return list.map((item) => {
      const item2 = priceMap[item.ccy];
      if (item2) {
        const priceChangePct24h = item2.priceChangePct24h || item.priceChangePct24h;
        const priceChangePct24hDisplay = numUtil.floor(Math.abs(priceChangePct24h || '0'), 2, -2) + '%';
        return {...item, ...item2, tradeLink: fixLink(`${LINKS.PHEMEX_MEME_TRADE}/${item2.chainId}/${item2.ccy}`), priceChangePct24hDisplay};
      }
      return {...item, tradeLink: fixLink(`${LINKS.PHEMEX_MEME_TRADE}/${item.chainId}${item.ccy}`)};
    });
  }),
  startWith([]),
  shareReplay(1)
);
